import { shouldHideProjectName } from './project-name-visibility';

/**
 * Anzeigename für den Transient-Projekt-Banner („Projekt … wurde vorübergehend
 * für diesen Punkt geöffnet"). Der Banner selbst erscheint immer (steuert die
 * Komponente), aber der **Projektname** wird für rein lesende Nutzer
 * verschleiert (Datenschutz 2026-06-13):
 *
 *  - **Datennutzer** → `null` (Banner ohne Name)
 *  - **nicht angemeldet** → `null` (Banner ohne Name)
 *  - **angemeldete, editierberechtigte Rolle** → echter Projektname
 *    (Fallback `'Unbenanntes Projekt'`, wenn das Projekt keinen Namen hat)
 *
 * Gate via {@link shouldHideProjectName} (gemeinsam mit dem Frozen-Banner).
 * Rein (kein Angular-DI) für einfache Testbarkeit.
 */
export function transientProjectBannerName(
	projectName: string | null | undefined,
	isAuthenticated: boolean,
	isDatennutzer: boolean
): string | null {
	if (shouldHideProjectName(isAuthenticated, isDatennutzer)) return null;
	return projectName || 'Unbenanntes Projekt';
}
